
    var riot = require('riot')
    //src: starling/src/tags/connection-error-banners.html
riot.tag2('connection-error-banners',
  '<span if="{opts.operation.isDisconnected() && !opts.operation.isLoggedOut()}" class="connection-error-banner reconnecting"> reconnecting... </span> <span if="{opts.operation.isDisconnected() && opts.operation.isLoggedOut()}" class="connection-error-banner reconnecting"> you\'ve been logged out. </span> <span if="{this.isStopTheWorldError()}" class="connection-error-banner error"> <i class="material-icons">warning</i> Something went wrong <a class="error-reload-button" href=""> Reload page </a> </span>',
  '',
  '', function(opts) {
"use strict";

var _opts = opts,
    store = _opts.store,
    operation = _opts.operation;

this.isStopTheWorldError = function () {
    return store.stopTheWorldError;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('connection-error-banners')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/connection-error-banners.html
// module id = 673
// module chunks = 0